import { partnerProfileConstants } from '../actions/constants';

const initialState = {
    categoryModels: {}, // Объект: { [categorySlug]: [models] }
    geometries: {},
    dimensions: {},
    materials: {},
    loading: false,
    error: null,
    karkasLoaded: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case partnerProfileConstants.GET_FENCE_MODELS_BY_CATEGORY_REQUEST:
        case partnerProfileConstants.LOAD_MODEL_GEOMETRY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case partnerProfileConstants.GET_FENCE_MODELS_BY_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                categoryModels: {
                    ...state.categoryModels,
                    [action.payload.categorySlug]: action.payload.models,
                },
                error: null,
            };
        case partnerProfileConstants.LOAD_MODEL_GEOMETRY_SUCCESS:
            return {
                ...state,
                loading: false,
                geometries: {
                    ...state.geometries,
                    [action.payload.modelPath]: action.payload.geometry,
                },
                dimensions: {
                    ...state.dimensions,
                    [action.payload.modelPath]: action.payload.dimensions,
                },
                materials: action.payload.materials
                    ? {
                        ...state.materials,
                        [action.payload.modelPath]: action.payload.materials,
                    }
                    : state.materials,
                error: null,
            };

        case partnerProfileConstants.GET_FENCE_MODELS_BY_CATEGORY_FAILURE:
        case partnerProfileConstants.LOAD_MODEL_GEOMETRY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                ...(action.type === partnerProfileConstants.LOAD_MODEL_GEOMETRY_FAILURE && {
                    geometries: {
                        ...state.geometries,
                        [action.payload.modelPath]: undefined,
                    },
                    dimensions: {
                        ...state.dimensions,
                        [action.payload.modelPath]: undefined,
                    },
                    materials: {
                        ...state.materials,
                        [action.payload.modelPath]: undefined,
                    },
                }),
            };

        case partnerProfileConstants.RESET_PARTNER_PROFILE:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};